import { APP_ENV, SENTRY_DSN } from 'astro:env/client';
// @ts-expect-error -- No default exports w/ JSON files
import pkg from '@/root/package.json' with { type: 'json' };

/** @type {import('@sentry/core').Options | import('@sentry/astro').BrowserOptions | import('@sentry/astro').NodeOptions} */
export default {
	allowUrls: [/https?:\/\/.*\.gametime\.co/],
	denyUrls: [
		/adsbygoogle.js/,
		/chrome-extension:\/\//,
		/edge-extension:\/\//,
		/googletagmanager.com/,
		/moz-extension:\/\//,
		/safari-extension:\/\//,
	],
	dsn: SENTRY_DSN,
	enableLogs: true,
	environment: APP_ENV,
	release: pkg.version,
	sendDefaultPii: false,
	tracePropagationTargets: [/\.gametime\.co$/],
	tracesSampleRate: 1.0,
};
